<template>
  <div :class="{
      'animated fadeIn': true,
      card,
    }" v-if="entity">

    <div v-if="card" class="card-header">
      <slot name="header"></slot>
    </div>

    <div :class="{ 'card-body': card }">
      <form class="form-inline form-inputs" @submit.prevent="firstPageSearch">
        <div class="form-group col-sm-12 search">

        </div>
      </form>

      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { get, set, clone, merge, debounce } from 'lodash'
import EditElement from './DatatableElements/EditElement'
import DeleteElement from './DatatableElements/DeleteElement'
// import ViewElement from './DatatableElements/ViewElement'

export default {
  props: {
    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    },

    filter: {
      type: Object,
      default () { return {} }
    },

    card: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      processing: false,

      collection: [],

      pagination: {},
      emptyPagination: {
        current_page: 1,
        total: 0,
        last_page: null,
        from: 1,
        to: 1,
        per_page: 10
      },

      per_pageOptions: [10, 25, 50],

      input: {},
      emptyInput: {
        page: 1,
        per_page: 10,
        search: '',
        orderBy: { name: 'created_at', direction: 'desc' }
      },

      defaultActions: [
        // { component: ViewElement },
        { component: EditElement },
        { component: DeleteElement }
      ]
    }
  },

  watch: {
    entity (prev, next) {
      const nextEntity = get(next, 'key', null)
      const previousEntity = get(prev, 'key', null)

      if (nextEntity !== previousEntity) {
        this.pagination = clone(this.emptyPagination)
        this.input = clone(this.emptyInput)

        this.firstPageSearch()
      }
    }
  },

  computed: {
    options () { return this.entity.tableOptions || { fields: [], actions: [] } },

    actions () {
      if (this.entity.hiddenAction) {
        return []
      }
      return get(this.entity, 'tableOptions.actions', this.defaultActions)
    }
  },

  methods: {
    get,

    firstPageSearch () {
      this.input.page = this.pagination.current_page = 1

      this.search()
    },

    callDebouncedFirstPageSearch () {
      this.debouncedFirstPageSearch(this)
    },

    search () {
      const self = this

      self.$nextTick(() => {
        self.processing = true
        self.$Progress.start()
        let search = [self.input.search, self.filter]
        self.http
          .index({ params: Object.assign(merge(clone(self.input), { search: search }), {
            scopes: self.options.scopes || [],
            with: self.options.with || [],
            orderBy: self.options.orderBy || self.input.orderBy
          })})
          .then((res, body) => {
            self.$Progress.finish()
            self.processing = false
            self.collection = get(res.data, 'collection', [])
            self.pagination = get(res.data, 'pagination', clone(self.emptyPagination))

            self.pagination.per_page = parseInt(self.pagination.per_page, 10)
          })
          .catch((error) => {
            self.$Progress.fail()
            self.error = error
            self.processing = false
            self.collection = []
            self.pagination = clone(self.emptyPagination)

            return null
          })
      })
    },

    debouncedFirstPageSearch: debounce((context) => {
      context.input.page = context.pagination.current_page = 1

      context.search()
    }, 1000, { 'maxWait': 8000 }),

    sortCollection (field) {
      const self = this

      // If the current column is the same sorting
      if (get(self.input, 'orderBy.name', null) === field.key) {
        set(
          self.input,
          'orderBy.direction',
          get(self.input, 'orderBy.direction', 'desc') === 'asc' ? 'desc' : 'asc'
        )
      } else {
        set(self.input, 'orderBy.name', field.key)
        set(self.input, 'orderBy.direction', 'asc')
      }

      self.firstPageSearch()
    },

    applyFormatters (field, value) {
      let result = value

      if (field.formatters) {
        for (let i = 0; i < field.formatters.length; i++) {
          switch (field.formatters[i]['type']) {
            case 'date':
              result = moment(result, 'YYYY-MM-DD HH:mm::ss').format(field.formatters[i]['args'])
          }
        }
      }

      return result
    }

    // actExport: function (event) {
    //   let translateParams = this.getAllRefsValues('translate')
    //   translateParams._onepage = true
    //   this.http.index({
    //     params: translateParams
    //   }).then((res, body) => {
    //     let data = map(res.data.collection, partialRight(pick, entities[this.$route.params.entity].options.export))
    //     exportFromJSON({ data, fileName: this.$route.params.entity, exportType: 'xls' })
    //   }).catch((error) => {
    //     this.error = error
    //   })
    // }
  },

  created () {
    this.pagination = clone(this.emptyPagination)
    this.input = clone(this.emptyInput)

    this.firstPageSearch()
  }
}
</script>

<style lang="sass">

table
  thead
    th
      &.sortable
        cursor: pointer !important

        &.active
          background-color: #333

</style>



// WEBPACK FOOTER //
// src/components/ui/SimpleTable.vue